import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as userStore from './user';
import * as quoteStore from './quote';
import * as standaloneStore from './standalone';
import {userInitialState} from './user';
import {quoteInitialState} from './quote';
import {EnumQuoteServiceSalesType} from '../models/enum/enum-quote-service-sales-type';
import { CoreState } from './reducers';
import {standaloneInitialState, StandaloneState} from "./standalone";

const selectCoreState = createFeatureSelector<CoreState>('core');
const selectUserState = createSelector(selectCoreState, (state: CoreState) => state && state.user ? state.user : userInitialState);
const selectQuoteState = createSelector(selectCoreState, (state: CoreState) => state && state.quote ? state.quote : quoteInitialState);
export const selectStandaloneState = createSelector(selectCoreState, (state: CoreState) => state && state.standalone ? state.standalone : standaloneInitialState);
export const isUserAuthenticated = createSelector(selectUserState, userStore.isAuthenticated);
export const getEmployee = createSelector(selectUserState, userStore.getAuthenticatedEmployee);
export const getCurrentQuote = createSelector(selectQuoteState, quoteStore.getCurrentQuote);
export const getClientInfos = createSelector(selectQuoteState, quoteStore.getClientInfos);
export const getServiceLineByCode = (codeService: string) => createSelector(selectQuoteState,
    (selectQuoteState) => quoteStore.getServiceLineByCode(selectQuoteState, codeService));
export const getPricingItem = (codeService: string, salesType: EnumQuoteServiceSalesType, pricingitemid: string) => createSelector(selectQuoteState,
    (selectQuoteState) => quoteStore.getPricingItem(selectQuoteState, codeService, salesType, pricingitemid));
export const getReferential = createSelector(selectQuoteState, quoteStore.getReferential);
export const getReferentialByKey = (key:string) => createSelector(selectQuoteState,
    (selectQuoteState) => quoteStore.getReferentialByKey(selectQuoteState, key));
export const getReferentialServices = createSelector(selectQuoteState, quoteStore.getReferentialServices);
export const getReferentialServiceByCode = (serviceCode: string) => createSelector(selectQuoteState,
    (selectQuoteState) => quoteStore.getReferentialServiceByCode(selectQuoteState, serviceCode));
export const getReferentialServiceByCodeAndKey = (serviceCode: string, key:string) => createSelector(selectQuoteState,
    (selectQuoteState) => quoteStore.getReferentialServiceByCodeAndKey(selectQuoteState, serviceCode,key));
export const getCurrencyQuote =  createSelector(selectQuoteState, quoteStore.getCurrencyQuote);
export const getQuoteType =  createSelector(selectQuoteState, quoteStore.getQuoteType);
export const getRedirectedUrl = createSelector(selectUserState, userStore.getRedirectedUrl);
// Standalone
export const getCmcProductsSyncStatus =  createSelector(selectStandaloneState, standaloneStore.getCmcProductsSyncStatus);
export const getCmcClassificationsSyncStatus =  createSelector(selectStandaloneState, standaloneStore.getCmcClassificationsSyncStatus);
export const getNewCmcVersion =  createSelector(selectStandaloneState, standaloneStore.getNewCmcVersion)
export const getCurrentCmcVersion =  createSelector(selectStandaloneState, standaloneStore.getCurrentCmcVersion);
export const getSyncStatus =  createSelector(selectStandaloneState, standaloneStore.getSyncStatus);
export const getSyncStatusByCollectionName = (collectionName: string) =>
    createSelector(
        selectStandaloneState,
        (state: StandaloneState) => {
            return state.cmcCollectionsSyncStatus?.[collectionName];
        }
    );


